import { Avatar, IconButton, Typography } from '@mui/material';
import { getNameInitials, getUsername } from '@utils/helper';
import { useStyles } from './styles/UserAvatar.styles';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { useSelector } from 'react-redux';

interface UserAvatarProps {
    handleToggleProfile: (event: any) => void;
    toggled: boolean;
}

export const UserAvatar = ({ handleToggleProfile, toggled }: UserAvatarProps) => {
    const classes = useStyles();

    const authState = useSelector((state: any) => state.auth);

    const { IdToken } = authState;

    return (
        <div className={classes.userInfo} onClick={handleToggleProfile}>
            <Avatar variant='rounded' className={classes.rounded}>
                {getNameInitials(IdToken)}
            </Avatar>

            <Typography>{getUsername(IdToken)}</Typography>

            <IconButton color='inherit' aria-label='Open drawer' edge='start' className={classes.downIcon}>
                {toggled ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
        </div>
    );
};
